import { VALUE_UPDATE_EVENT } from "../../lib/constants.js";
import { createBlock, createVNode, openBlock, renderSlot, unref, withCtx } from "vue";
import { DtInput, DtText } from "@dialpad/dialtone-vue";
//#region src/components/controls/control_number.vue
var _sfc_main = /* @__PURE__ */ Object.assign({ name: "DtcControlNumber" }, {
	props: {
		value: {
			type: Number,
			default: () => Number()
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	emits: [VALUE_UPDATE_EVENT],
	setup(__props, { emit: __emit }) {
		const emit = __emit;
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(DtInput), {
				"model-value": __props.value,
				disabled: __props.disabled,
				type: "number",
				size: 100,
				onInput: _cache[0] || (_cache[0] = (e) => emit(unref("update:value"), e === "" ? void 0 : parseInt(e)))
			}, {
				label: withCtx(() => [createVNode(unref(DtText), {
					kind: "label",
					size: 100,
					tone: "secondary",
					class: "d-input__label-text"
				}, {
					default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
					_: 3
				})]),
				_: 3
			}, 8, ["model-value", "disabled"]);
		};
	}
});
//#endregion
export { _sfc_main as default };

//# sourceMappingURL=control_number.vue.js.map